import React, { Component } from 'react';
import './under-maintenance-popup.less';

class UnderMaintenancePopup extends Component {
	render() {
		return (
			<div className="maintenance-popup_container font-proxima-nova-bold">
				<div className="maintenance-popup_content">
					<span>
						{'Technical work is in progress. Website will be available soon'}
					</span>
				</div>
			</div>
		);
	}
}

export default UnderMaintenancePopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/under-maintenance-popup.js